module.exports = __webpack_public_path__ + "static/img/qiepian11.12f7f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qiepian11.png
// module id = oBSq
// module chunks = 2